var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 12.2625L0.104263 0.5375L12.0044 8.46875C12.1538 8.56875 12.353 8.56875 12.5023 8.46875L25 0L12.4588 12.2625C12.3032 12.4125 12.0542 12.4125 11.8986 12.2625Z",
    fill: "url(#paint0_linear_289_188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_188",
    x1: -0.763406,
    y1: -30.0535,
    x2: -11.2467,
    y2: -27.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#976360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#6D4036"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDArr);
export default __webpack_public_path__ + "static/media/d_arr.c81c95c4af7a3bfbc9d11651073496b2.svg";
export { ForwardRef as ReactComponent };